(function () {
  function init() {
    var pickup = document.querySelector('pickup-availability');
    // Suffix-match since Shopify prefixes this id with a runtime section key
    // that isn't stable to hardcode.
    var trustAnchor = document.querySelector('[id*="conversion_bear_trust_badges_widget"]');
    if (!pickup || !trustAnchor) return;
    if (pickup.dataset.reordered) return;
    pickup.dataset.reordered = '1';

    // Desired order on the product page: Add to Cart button(s) -> "Secure
    // Checkout With" trust badges -> Pickup availability -> shipping
    // timeline box. Pickup availability normally renders glued directly
    // under the buy buttons (it's part of that same block's own markup),
    // so block re-ordering alone can't separate it from the buttons. Move
    // it to sit right after the trust badges block instead. This element
    // isn't destroyed/recreated on variant change (product-info.js only
    // updates its innerHTML in place), so a one-time move on load is enough.
    trustAnchor.parentNode.insertBefore(pickup, trustAnchor.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
